import { useEffect, useState } from "react";
import "./ReviewIndex.css";

const baseUrl = import.meta.env.VITE_API_URL;

type CustomerData = {
  Customer: string;
  Mobile: string;
  Reference: string;
};

const ReviewIndex = () => {
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);
  const [comments, setComments] = useState("");
  const [slug, setSlug] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [customer, setCustomer] = useState<CustomerData>({
    Customer: "",
    Mobile: "",
    Reference: "",
  });

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const slugParam = params.get("invoiceRef");
    console.log("Slug Param:", slugParam);
    if (slugParam) {
      setSlug(slugParam);
      fetchCustomer(slugParam);
    }
  }, []);

  const fetchCustomer = async (invoiceRef: string) => {
    try {
      const res = await fetch(`${baseUrl}/api/reviewapi/getInvoice/?invoiceRef=${invoiceRef}`);
      if (!res.ok) throw new Error("Failed to fetch customer data");
      const data = await res.json();
      setCustomer({
        Customer: data.customer,
        Mobile: data.mobile,
        Reference: data.reference,
      });
    } catch (err) {
      console.error(err);
      alert("Failed to load customer data");
    }
  };

  const isDisabled = Boolean(slug);

  const handleSubmit = async () => {
    if (rating === 0) {
      alert("Please select a rating.");
      return;
    }

    setLoading(true);

    const payload = {
      Customer: customer.Customer,
      Mobile: customer.Mobile,
      Reference: customer.Reference,
      Rating: rating,
      Comments: comments || "-",
    };

    try {
      const response = await fetch(`${baseUrl}/api/reviewapi`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!response.ok) throw new Error("Failed to submit review");

      const data = await response.json();
      if (data) {
        window.location.href = "/";
      }
    } catch (err) {
      console.error(err);
      alert("Failed to submit review.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="Review">
      {/* Header */}
      <div className="topbar">
        <img
          src="https://goodhand.b-cdn.net/Assets/logo-main-gFDCiCbr.svg"
          alt="Goodhand Logo"
          className="img-fluid"
        />
      </div>

      {/* Review Section */}
      <section className="review-section">
        <div className="review-card">
          <h5>Review</h5>

          <div className="mb-3">
            <label>
              Customer Name {!isDisabled && <span className="text-muted"> (Optional)</span>}
            </label>
            <input
              type="text"
              className="form-control"
              value={customer.Customer}
              disabled={isDisabled}
              onChange={(e) => setCustomer({ ...customer, Customer: e.target.value })}
            />
          </div>

          <div className="mb-3">
            <label>
              Mobile No {!isDisabled && <span className="text-muted"> (Optional)</span>}
            </label>
            <div className="input-group">
              <span className="input-group-text bg-light border-0">+971</span>
              <input
                type="text"
                className="form-control"
                value={customer.Mobile}
                disabled={isDisabled}
                onChange={(e) => setCustomer({ ...customer, Mobile: e.target.value })}
              />
            </div>
          </div>

          <div className="mb-3">
            <label>
              Reference Case or Invoice {!isDisabled && <span className="text-muted"> (Optional)</span>}
            </label>
            <input
              type="text"
              className="form-control"
              value={customer.Reference}
              disabled={isDisabled}
              onChange={(e) => setCustomer({ ...customer, Reference: e.target.value })}
            />
          </div>

          <div className="mb-3">
            <label>
              Rating <span className="required">*</span>
            </label>
            <div className="stars-1">
              {[1, 2, 3, 4, 5].map((i) => (
                <i
                  key={i}
                  className={`fa-star fa-solid star-1 ${i <= (hover || rating) ? "active" : ""}`}
                  onClick={() => setRating(i)}
                  onMouseEnter={() => setHover(i)}
                  onMouseLeave={() => setHover(rating)}
                ></i>
              ))}
            </div>
          </div>

          <div className="mb-3">
            <label>
              Comments <span className="text-muted">(Optional)</span>
            </label>
            <textarea
              className="form-control"
              rows={4}
              placeholder="Write your feedback..."
              value={comments}
              onChange={(e) => setComments(e.target.value)}
            ></textarea>
          </div>

          <div className="col-md-12 text-center">
            <button
              className="save-btn"
              onClick={handleSubmit}
              disabled={loading || rating === 0}
            >
              {loading ? "Saving..." : "Save"}
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ReviewIndex;
